import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject, fromEvent } from 'rxjs';
import { map, pluck, distinctUntilChanged } from 'rxjs/operators';

export enum ScreenSize {
    XXSmall, // 0
    XSmall, // 1
    Small, // 2
    Medium, // 3
    Large, // 4
    ExtraLarge // 5
}

class BreakPoints {
    xxSmall = 1024;
    xSmall = 1366;
    small = 1440;
    medium = 1679;
    large = 1920;
}

@Injectable({
    providedIn:"root"
})
export class WindowService {

    //height$: Observable<number>;
    //width$: Observable<number>;
    size$: Observable<number>;

    constructor() {
        const windowSize$ = new BehaviorSubject(getWindowSize());
        // this.height$ = (windowSize$.pluck('height') as Observable<number>).distinctUntilChanged();
        // this.width$ = (windowSize$.pluck('width') as Observable<number>).distinctUntilChanged();
        this.size$ = (windowSize$.pipe(pluck('size')) as Observable<number>).pipe(distinctUntilChanged());

        fromEvent(window, 'resize').pipe
            (map(getWindowSize))
            .subscribe(windowSize$);
    }
}

function getWindowSize() {
    const breakPoints = new BreakPoints;
    let screenSize = ScreenSize.ExtraLarge;
    let devicePixelRatio = 1;
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (isMac) {
        // if (window.devicePixelRatio >= 2) {
        //     devicePixelRatio = (window.devicePixelRatio / 2);
        // }
    } else {
        // devicePixelRatio = window.innerWidth < 1366 ? window.devicePixelRatio : 1; // innerWidth如果小于1366启用
        // devicePixelRatio = window.innerWidth < 1366 ? (1366 / window.innerWidth) : 1; // innerWidth如果小于1366启用，使用最小尺寸
        devicePixelRatio = window.innerWidth < 1366 ? (1366 / window.innerWidth) : window.innerWidth > 2560 ? (1920 / window.innerWidth) : 1; // innerWidth如果小于1366启用，使用最小尺寸;大于2560启用，使用最大尺寸
    }
    const actualInnerWidth = Math.ceil(window.innerWidth * devicePixelRatio);
    if (actualInnerWidth < breakPoints.xxSmall) {
        screenSize = ScreenSize.Small;
    } else if (actualInnerWidth < breakPoints.xSmall) {
        screenSize = ScreenSize.Small;
    } else if (actualInnerWidth < breakPoints.small) {
        screenSize = ScreenSize.Small;
    } else if (actualInnerWidth >= breakPoints.small && actualInnerWidth < breakPoints.medium) {
        screenSize = ScreenSize.Medium;
    } else if (actualInnerWidth >= breakPoints.medium && actualInnerWidth < breakPoints.large) {
        screenSize = ScreenSize.Large;
    } else {
        screenSize = ScreenSize.ExtraLarge;
    }
    // if (window.innerWidth < breakPoints.xxSmall) {
    //     screenSize = ScreenSize.Small;
    // } else if (window.innerWidth < breakPoints.xSmall) {
    //     screenSize = ScreenSize.Small;
    // } else if (window.innerWidth < breakPoints.small) {
    //     screenSize = ScreenSize.Small;
    // } else if (window.innerWidth >= breakPoints.small && window.innerWidth <= breakPoints.medium) {
    //     screenSize = ScreenSize.Medium;
    // } else if (window.innerWidth >= breakPoints.medium && window.innerWidth < breakPoints.large) {
    //     screenSize = ScreenSize.Large;
    // } else {
    //     screenSize = ScreenSize.ExtraLarge;
    // }

    return {
        size: screenSize,
        height: window.innerHeight,
        width: window.innerWidth
    };
}
